package ru.it_mozaika.sender.js.application.routes

import js.core.jso
import react.create
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.context.PropertiesProvider
import ru.it_mozaika.sender.js.application.frames.properties.PropertiesFrame

val propertyRoutes = jso<RouteObject> {
    path = "properties"
    children = arrayOf(
        jso {
            path = ""
            index = true
            element = PropertiesProvider.create{
                PropertiesFrame{}
            }
        }
    )

}
